import _ from 'lodash'
export const STATIC_PATH = `${process.env.PUBLIC_PATH}${ process.env.NODE_ENV === 'development' ? 'static/' : '_razzle/static/' }`
export const TRANSLATE_DEFAULT_LANGUAGE = process.env.RAZZLE_TRANSLATE_DEFAULT_LANGUAGE
export const TRANSLATE_LANGUAGES = JSON.parse(process.env.RAZZLE_TRANSLATE_LANGUAGES || '[]')

export const WORDPRESS_BASE_TEMPLATE_URL_FR = process.env.RAZZLE_WORDPRESS_BASE_TEMPLATE_URL_FR
export const WORDPRESS_BASE_TEMPLATE_URL_EN = process.env.RAZZLE_WORDPRESS_BASE_TEMPLATE_URL_EN
export const WORDPRESS_BASE_TEMPLATE_URL_ES = process.env.RAZZLE_WORDPRESS_BASE_TEMPLATE_URL_ES

export const BASE_URL = process.env.RAZZLE_BASE_URL
export const BASE_API_URL = process.env.RAZZLE_BASE_API_URL
export const GOOGLE_MAP_LANGUAGE = process.env.RAZZLE_GOOGLE_MAP_LANGUAGE || 'fr'
export const GOOGLE_MAP_API_KEY = process.env.RAZZLE_GOOGLE_MAP_API_KEY


export const NUMBER_OF_PASSENGERS_UUID = process.env.RAZZLE_NUMBER_OF_PASSENGERS_UUID || '58627bef-8146-43b5-bd99-7a04af8cf681'
export const NUMBER_OF_BEDS_UUID = process.env.RAZZLE_NUMBER_OF_BEDS_UUID || 'f4fe4cc3-0997-4602-ad1e-ffa72d7b6bfc'


export const RIGHT_MESSAGE_UUID = process.env.RAZZLE_RIGHT_MESSAGE_UUID || '0dd3ee2c-07c4-4634-889e-c3868f960a70'
export const RIGHT_RESERVATION_UUID = process.env.RAZZLE_RIGHT_RESERVATION_UUID || 'c639706e-be98-4a19-8007-6cf099d93f7e'


export const SPECIFICITIES_ORDERS = [
    {
        "label": "Caractéristiques téchniques",
        "icon": "fas fa-wrench",
        "orders": [
            "683b19d8-f004-4283-97b6-3a6020091650",
            "e3cd3ce8-7329-4886-85f1-d8c23d0cf659",
            "b3ad27a6-b1d9-4113-9c64-97eb46f9de5f",
            "429af46f-51fb-439d-803e-a4d983f72b81",
            "cbcfdc33-9978-4eb6-a0ef-4da5fc850af4",
            "35a699ed-bae8-4f24-837d-9f710451bf1a",
            "cd7c0284-adef-4e3d-b639-0ba6b70cc2b1",
            "1d8f5df0-fe3f-4b36-8751-eb0a1fb5679f",
            "9eec3a48-8556-42a9-b3e6-8dfd54e34daa",
            "adc78fce-8484-4ed3-a9a4-71650022752b",
            "6325f231-07f2-4649-b554-afe3ff9dec3d",
            "18b8e246-beb2-4207-b4db-34df0f5aa1d1",
            "79f3115f-c1ed-4467-a610-f63ee79f0eaf",
            "1f8fb395-980d-4f50-b694-0326ced42e1a"

        ]
    },
    {
        "label": "Vie à bord",
        "icon": "fas fa-bed",
        "orders": [
            "819c5c05-02cf-47a2-8f9e-89b8f422913b",
            "8b7501ad-b724-4998-aa36-cf3d9cfce8d2",
            "6a6bfc5f-464b-433f-a4b6-2fb9e9cced06",
            "652a2851-beef-4c72-be5a-31047a6b642b",
            "71c8677b-0507-4e34-881d-bfd9b4ba668f",
            "19f11302-93f4-4b96-afbb-2a4d32c51717",
            "e3f4b199-8a90-4f08-8934-0bc11812e3de"
        ]
    },

    {
        "label": "Autonomie",
        "icon": "fas fa-car-battery",
        "orders": [
            "02a6f460-eb68-421b-a672-edf00b2045fd",
            "49f1884f-f08b-467c-a5f8-88851d8fff74",
            "275aa143-9ba8-4b64-b4b4-4e5472024aaa",
            "d7be84dc-559d-45b3-88b2-d38879922ffb"
        ]
    },
    {
        "label": "Equipement",
        "icon": "fas fa-caravan",
        "orders": [
            "c9af2282-138b-4fe6-8e38-c525a9749c6d"
        ]
    }
]

export const PERIODICITY_RECIPROCAL_EXCHANGE_UUID = '245c7ab1-383a-47f7-9d29-8f33383f0dd3'
export const PERIODICITY_NO_RECIPROCAL_EXCHANGE_UUID = 'a97fb364-33b8-41f1-8d96-e4e466b78218'
export const PERIODICITY_ALL_TYPE_EXCHANGE_UUID = 'ca12e84e-610a-4841-a686-2d8a9d11bca1'
export const CERTIFIED_VEHICLE_TAG_UUID=process.env.RAZZLE_CERTIFIED_VEHICLE_TAG_UUID
